module.exports = __webpack_public_path__ + "static/img/1.2fa82e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/realisations/ennetieresPortail/1.jpg
// module id = Ogj7
// module chunks = 0